import React, { Component } from 'react';
import {toast } from 'react-toastify';
import cookie from 'react-cookies';
import $ from 'jquery';
import {updateValueInJson, esUrl, showModalPageClass, hideModalPageClass} from '../../../../../functions';
import axios from 'axios';
import {API_URL} from '../../../../../constants';
import ModalMultimedia from '../../../../Partials/ModalMultimedia';

export default class AdmModuloReporteExportacion extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            modulo: this.props.modulo,
            tituloLongitud:0,
            descripcionLongitud:0,  
            resource:{
                pmod_Id:0,
                pagi_Id:this.props.pagina,
                mweb_Id:this.props.modulo.id,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mrex_Titulo:"",
                mrex_Descripcion:"",
                mrex_ImagenPortada:"",
                mrex_TextoEnlace:"",
                mrex_Enlace:"",
                mrex_Activo:true
            },
            resourceEdit:{
                pmod_Id:0,
                pmod_ClaseAncla:"",
                pmod_Sect_Id:0,
                pmod_Pweb_Id:0,

                mrex_Id:0,
                mrex_Titulo:"",
                mrex_Descripcion:"",
                mrex_ImagenPortada:"",
                mrex_TextoEnlace:"",
                mrex_Enlace:"",
                mrex_Activo:true
            },
            Validacion: {
                mrex_Titulo: {
                    Error: false,                    
                },
                mrex_Descripcion: {
                    Error: false,                    
                },
                mrex_ImagenPortada: {
                    Error: false,                    
                },
                mrex_TextoEnlace: {
                    Error: false,                    
                },
                mrex_Enlace: {
                    Error: false,                    
                }
            },
            ValidacionEdit:{
                mrex_Titulo: {
                    Error: false,                    
                },
                mrex_Descripcion: {
                    Error: false,                    
                },
                mrex_ImagenPortada: {
                    Error: false,                    
                },
                mrex_TextoEnlace: {
                    Error: false,                    
                },
                mrex_Enlace: {
                    Error: false,                    
                }
            },
            perfiles: this.props.perfiles,
            sectores: this.props.sectores,
            hasError:false,
            added:false,
            confirmStore:false,
            security: cookie.load('user'),
            roles: [], 
            fieldReturnMultimedia:""
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeEdit = this.handleInputChangeEdit.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
    }

    getResponseMultimedia = (urlSeleccionada) => {

        let resource = this.state.isEditfieldReturnMultimedia ? this.state.resourceEdit : this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;
    
        if(fieldReturn!== ""){
    
            resource[fieldReturn] = urlSeleccionada;
            
            if(this.state.isEditfieldReturnMultimedia){
                this.setState({resourceEdit:resource, fieldReturnMultimedia:"", isEditfieldReturnMultimedia:false});
            }else{
                this.setState({resource:resource, fieldReturnMultimedia:""});
            }
        }
    
        hideModalPageClass("divGestorArchivosRepExp");
    }
    
    showModalMultimedia = (clase = "", campo = "", isEdition = false) => {
        this.setState({fieldReturnMultimedia:campo, isEditfieldReturnMultimedia:isEdition});
        showModalPageClass(clase);
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mrex_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'mrex_Descripcion'){
            descripcionLongitud = value.length;
        }

        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            descripcionLongitud: descripcionLongitud,
            Validacion: validaciones
        });  
    }

    handleInputChangeEdit(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resourceEdit;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;

        let validaciones = this.state.ValidacionEdit;

        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'mrex_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'mrex_Descripcion'){
            descripcionLongitud = value.length;
        }

        this.setState({
            resourceEdit: copyResource,
            tituloLongitud: tituloLongitud,
            descripcionLongitud: descripcionLongitud,
            ValidacionEdit: validaciones
        });  
    }

    storeModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.mrex_Titulo == '') {              
            newState.Validacion.mrex_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mrex_Descripcion == '') {  
            newState.Validacion.mrex_Descripcion = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mrex_ImagenPortada == '') {              
            newState.Validacion.mrex_ImagenPortada = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mrex_TextoEnlace == '') {  
            newState.Validacion.mrex_TextoEnlace = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.mrex_Enlace == '') {  
            newState.Validacion.mrex_Enlace = {Error: true};
            newState.hasError = true;
        } 
        
        if (newState.resource.mrex_Enlace !== '' && !esUrl(newState.resource.mrex_Enlace)) {  
            newState.Validacion.mrex_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloReporteExportacionUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'mrex_UsuarioCreacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.post(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let result = data.data.result;
                let stateResponse = this.state;

                stateResponse.added = true;

                stateResponse.resource.mrex_Titulo = '';
                stateResponse.resource.mrex_Descripcion = '';
                stateResponse.resource.mrex_ImagenPortada = '';
                stateResponse.resource.mrex_TextoEnlace = '';
                stateResponse.resource.mrex_Enlace = '';

                stateResponse.resource.pmod_Id = result.pmod_Id;

                document.getElementById("pweb_Id").selectedIndex = 0;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 

                this.props.callback(true);

                $(".divClosePopup_Modals").trigger("click");

            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    updateModulo = (e) => {

        if(e != undefined){
            e.preventDefault();
        }

        let newState = this.state;
        newState.hasError = false;

        if (newState.resourceEdit.mrex_Titulo == '') {              
            newState.ValidacionEdit.mrex_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mrex_Descripcion == '') {  
            newState.ValidacionEdit.mrex_Descripcion = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mrex_ImagenPortada == '') {              
            newState.ValidacionEdit.mrex_ImagenPortada = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mrex_TextoEnlace == '') {  
            newState.ValidacionEdit.mrex_TextoEnlace = {Error: true};
            newState.hasError = true;
        }
        if (newState.resourceEdit.mrex_Enlace == '') {  
            newState.ValidacionEdit.mrex_Enlace = {Error: true};
            newState.hasError = true;
        }  
        
        if (newState.resourceEdit.mrex_Enlace !== '' && !esUrl(newState.resourceEdit.mrex_Enlace)) {  
            newState.ValidacionEdit.mrex_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}ModuloReporteExportacionUX/`;
        var dataForm = this.state.resourceEdit;
        dataForm = updateValueInJson(dataForm,'mrex_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                this.setState({added:true});

                setTimeout(() => { 
                    this.setState({added:false});
                }, 3000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    closeModulo = () => {

        let resource = this.state.resource;
        resource.pmod_Id = 0;
        
        let resourceEdit = this.state.resourceEdit;
        resourceEdit.mrex_Id = 0;
        this.setState({resource:resource, resourceEdit:resourceEdit});

        this.props.callback(true);
        
    }
  

    loadModulo = (pmod_Id) => 
    {
        const url = `${API_URL}ModuloReporteExportacionUX/Seleccionar/${pmod_Id}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resourceEdit: data.result, response: data, error: data.Error });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    }    
    
    componentWillReceiveProps(nextProps){

        let mweb = 18;

        if(nextProps.pmodId !== this.state.resource.pmod_Id && mweb == nextProps.mWebEdit){
            let resource = this.state.resource;
            resource.pmod_Id = nextProps.pmodId;

            this.setState({resource: resource});

            setTimeout(() => { 
                this.loadModulo(resource.pmod_Id);
            }, 100); 
        }
      } 

    render() {

        let modulo = this.state.modulo;

        return (
            <div className="divModalBanner popUpGeneral" id={"modal_" + modulo.id} style={{display:"none"}}>
                <div className="divLayerPopup_ModalPaginas">
                    <div className="divPopup_ModalPaginas">
                    <div className="divClosePopup_Modals" onClick={() => this.closeModulo()}/>
                    <h2>{modulo.nombre} </h2>
                    <div className="divWrapperModalPaginas">

                        {
                            this.state.resourceEdit.mrex_Id > 0 ?
                            <React.Fragment>
                            <div className="containerFormCreation divModuloPopup_Panel">
                                {
                                    this.state.added ?
                                    <div className="txtFile x-1">
                                        <strong style={{
                                            display: "block",
                                            textAlign:"center",
                                            color: "#008000a3"
                                        }}> Registro actualizado satisfactoriamente!!</strong>
                                    </div> : null
                                }
                                
                                <div className="textareaResumen x-1">
                                    <input type="text" placeholder="Título" 
                                    value={this.state.resourceEdit.mrex_Titulo} 
                                    name="mrex_Titulo"  
                                    className={this.state.ValidacionEdit.mrex_Titulo.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit} 
                                    maxLength={50} />
                                    <span data-length={50}>{this.state.tituloLongitud}/50</span>
                                </div>

                                <div className="textareaResumen x-1">
                                    <textarea placeholder="Descripción" 
                                    value={this.state.resourceEdit.mrex_Descripcion} 
                                    name="mrex_Descripcion"  
                                    className={this.state.ValidacionEdit.mrex_Descripcion.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit} 
                                    style={{height:"100px"}}
                                    maxLength={180} />
                                    <span data-length={180}>{this.state.descripcionLongitud}/180</span>
                                </div>

                                <div className="txtFile x-1 relative">
                                    <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosRepExp", "mrex_ImagenPortada", true)}/>
                                    <input type="text" placeholder="Imagen Portada" 
                                    value={this.state.resourceEdit.mrex_ImagenPortada} 
                                    name="mrex_ImagenPortada"  
                                    className={this.state.ValidacionEdit.mrex_ImagenPortada.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit} />
									<label class="recomendacion">Se recomienda la dimensión de 308px de ancho X 178px de alto.</label>
                                </div>

                                <div className="textareaResumen x-1">
                                    <input type="text" placeholder="Texto de Enlace" 
                                    value={this.state.resourceEdit.mrex_TextoEnlace} 
                                    name="mrex_TextoEnlace"  
                                    className={this.state.ValidacionEdit.mrex_TextoEnlace.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit}  />
                                </div>

                                <div className="textareaResumen x-1">
                                    <input type="text" placeholder="Enlace" 
                                    value={this.state.resourceEdit.mrex_Enlace} 
                                    name="mrex_Enlace"  
                                    className={this.state.ValidacionEdit.mrex_Enlace.Error ? "error" : ""}
                                    onChange={this.handleInputChangeEdit}  />
                                </div>
                                

                                <div className="divModulo_Seo">
                                    <h2><strong>Configuración de modulo</strong></h2>
                                    <div className="divWrapperModulo_Seo">
                                        
                                        <div className="txtFile x-2">
                                            <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resourceEdit.pmod_ClaseAncla}  
                                            onChange={this.handleInputChangeEdit}/>
                                        </div>	

                                        <div className="txtFile x-1">
                                            <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                            onChange={this.handleInputChangeEdit} >
                                                <option value="0">Seleccionar Perfil</option>
                                                {
                                                    this.state.perfiles.length > 0 ?
                                                    this.state.perfiles.map((perfil) => (
                                                        <option value={perfil.id} selected={(this.state.resourceEdit.pmod_Pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                                    ))
                                                    : null
                                                }
                                            </select>                        
                                        </div>

                                        <div className="txtFile x-1">
                                            <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                            onChange={this.handleInputChangeEdit} >
                                                <option value="0">Seleccionar Sector</option>
                                                {
                                                    this.state.sectores.length > 0 ?
                                                    this.state.sectores.map((sector) => (
                                                        <option value={sector.id} selected={(this.state.resourceEdit.pmod_Sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                                    ))
                                                    : null
                                                }
                                            </select>                        
                                        </div>
                                        
                                    </div>
                                </div>



                            </div>
                            <div>
                                <a href="" className="btnAgregarPagina noneEvent" id="btnActualizarPerfilador" onClick={(e) => this.updateModulo(e)}>ACTUALIZAR</a>
                                <br/>
                                <br/>
                                <br/>
                            </div>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <div className="containerFormCreation divModuloPopup_Panel">

                                    
                                    <div className="textareaResumen x-1">
                                        <input type="text" placeholder="Título" 
                                        value={this.state.resource.mrex_Titulo} 
                                        name="mrex_Titulo"  
                                        className={this.state.Validacion.mrex_Titulo.Error ? "error" : ""}
                                        onChange={this.handleInputChange} 
                                        maxLength={50} />
                                        <span data-length={50}>{this.state.tituloLongitud}/50</span>
                                    </div>

                                    <div className="textareaResumen x-1">
                                        <textarea placeholder="Descripción" 
                                        value={this.state.resource.mrex_Descripcion} 
                                        name="mrex_Descripcion"  
                                        className={this.state.Validacion.mrex_Descripcion.Error ? "error" : ""}
                                        onChange={this.handleInputChange} 
                                        style={{height:"100px"}}
                                        maxLength={180} />
                                        <span data-length={180}>{this.state.descripcionLongitud}/180</span>
                                    </div>

                                    <div className="txtFile x-1 relative">
                                        <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosRepExp", "mrex_ImagenPortada")}/>
                                        <input type="text" placeholder="Imagen Portada" 
                                        value={this.state.resource.mrex_ImagenPortada} 
                                        name="mrex_ImagenPortada"  
                                        className={this.state.Validacion.mrex_ImagenPortada.Error ? "error" : ""}
                                        onChange={this.handleInputChange} />
										<label class="recomendacion">Se recomienda la dimensión de 308px de ancho X 178px de alto.</label>
                                    </div>

                                    <div className="textareaResumen x-1">
                                        <input type="text" placeholder="Texto de Enlace" 
                                        value={this.state.resource.mrex_TextoEnlace} 
                                        name="mrex_TextoEnlace"  
                                        className={this.state.Validacion.mrex_TextoEnlace.Error ? "error" : ""}
                                        onChange={this.handleInputChange} />
                                    </div>

                                    <div className="textareaResumen x-1">
                                        <input type="text" placeholder="Enlace" 
                                        value={this.state.resource.mrex_Enlace} 
                                        name="mrex_Enlace"  
                                        className={this.state.Validacion.mrex_Enlace.Error ? "error" : ""}
                                        onChange={this.handleInputChange}  />
                                    </div>



                                    <div className="divModulo_Seo">
                                        <h2><strong>Configuración de modulo</strong></h2>
                                        <div className="divWrapperModulo_Seo">
                                            
                                            <div className="txtFile x-2">
                                                <input type="text" placeholder="Anclaje del modulo" name='pmod_ClaseAncla' value={this.state.resource.pmod_ClaseAncla}  
                                                onChange={this.handleInputChange}/>
                                            </div>	

                                            <div className="txtFile x-1">
                                                <select name='pmod_Pweb_Id' id='pmod_Pweb_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Perfil</option>
                                                    {
                                                        this.state.perfiles.length > 0 ?
                                                        this.state.perfiles.map((perfil) => (
                                                            <option value={perfil.id} key={perfil.id}>{perfil.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>

                                            <div className="txtFile x-1">
                                                <select name='pmod_Sect_Id' id='pmod_Sect_Id' 
                                                onChange={this.handleInputChange} >
                                                    <option value="0">Seleccionar Sector</option>
                                                    {
                                                        this.state.sectores.length > 0 ?
                                                        this.state.sectores.map((sector) => (
                                                            <option value={sector.id}>{sector.nombre.toUpperCase()}</option>
                                                        ))
                                                        : null
                                                    }
                                                </select>                        
                                            </div>
                                            
                                        </div>
                                    </div>






                                </div>
                                <div>
                                    <a href="" className="btnAgregarPagina noneEvent" id="btnGuardarPerfilador" onClick={(e) => this.storeModulo(e)}>GUARDAR</a>
                                    <br/>
                                    <br/>
                                    <br/>
                                </div>
                            </React.Fragment>
                        }
                        
                        

                    </div>
                    </div>
                </div>
                <ModalMultimedia class="divGestorArchivosRepExp" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }
}
